import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { readContract } from "./errors";

const seconds = z.int().nonnegative();
export const ownUsageSchema = z.object({
  subscription: z.object({
    allowanceSeconds: seconds,
    usedSeconds: seconds,
    availableSeconds: seconds,
    periodStart: z.iso.datetime().nullable(),
    periodEnd: z.iso.datetime().nullable(),
  }),
  additional: z.object({ availableSeconds: seconds }),
});
export const accountUsageContract = {
  ownUsage: readContract
    .errors({
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      SERVICE_UNAVAILABLE: { message: "Usage unavailable" },
    })
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/me/usage",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(ownUsageSchema),
};
